import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=f1ae46a8&lang=pug"
import script from "./ClientsFilter.vue?vue&type=script&lang=js"
export * from "./ClientsFilter.vue?vue&type=script&lang=js"
import style0 from "./ClientsFilter.vue?vue&type=style&index=0&id=f1ae46a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports